export default __webpack_public_path__ + "static/media/copy-icon-plus.bf0417a0.svg";